import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useMemo } from 'react';
import { NumberBadge } from '@/components/ui/Badge/NumberBadge';
import { BorderTab, BorderTabs } from '@/components/ui/Tab/BorderTab';
import { Text } from '@/components/ui/Typography/Body/Text';
import { clientRfpOneFileAllPath, clientRfpOneFileOneNoDataPath, clientRfpOneFileOnePath, } from '@/utils/router/links';
// 表示タブの値
export const tabItemAll = { text: 'コンサルタント選択', value: 'all' };
export const tabItemOne = { text: '共有履歴の確認', value: 'one' };
/**
 * クライアント：ファイル共有ページ共通で表示させるタブリンク
 * @param props
 * @constructor
 */
export const RfpClientOneFileTab = (props) => {
    const { activeValue, className, id, unreadCount = 0, viewRequestId } = props;
    // タブ一覧
    const tabItems = useMemo(() => [
        Object.assign(Object.assign({}, tabItemAll), { to: clientRfpOneFileAllPath(id) }),
        Object.assign(Object.assign({}, tabItemOne), { count: unreadCount, to: viewRequestId
                ? clientRfpOneFileOnePath(id, viewRequestId)
                : clientRfpOneFileOneNoDataPath(id) }),
    ], [id, unreadCount, viewRequestId]);
    return (_jsx(BorderTabs, Object.assign({ className: className }, { children: tabItems.map((item) => (_jsx(BorderTab, Object.assign({ activeValue: activeValue, paddingClassName: 'py-8', to: item.to, value: item.value, widthClassName: 'w-full max-w-[216px]' }, { children: _jsxs("div", Object.assign({ className: 'flex items-center gap-x-4' }, { children: [_jsx(Text, Object.assign({ color: 'none', size: 'sm', tagName: 'span' }, { children: item.text })), item.count !== undefined && item.count > 0 && (_jsx(NumberBadge, { number: item.count }))] })) }), item.value))) })));
};
